<template>
    <div class="card-container">
        <el-card class="box-card">
            <m-p-search></m-p-search>
        </el-card>

        <el-card class="box-card" style="min-height: 53vh; margin-bottom: 0">
            <common-top-form :model="formModel" :selectShow="false" @openAddDialog="handleRepayApply" buttonName="代付">
                <el-form-item label="卡号">
                    <el-input type="text" maxlength="50" v-model="formModel.cardNo" placeholder="请输入卡号"></el-input>
                </el-form-item>
                <el-form-item label="金额">
                    <el-input-number v-model="formModel.amount" controls-position="right" :precision="2" :step="0.1"
                                     :controls="false"
                                     :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="支付类型">
                    <el-select v-model="formModel.payType">
                        <el-option
                            v-for="item in payTypes"
                            :key="item.dictKey"
                            :label="item.dictValue"
                            :value="item.dictKey">
                        </el-option>
                    </el-select>
                </el-form-item>
            </common-top-form>
            <common-table :data="tableData" ref="commonTable" @handleChange="getPage"  v-loading="loading">
                <el-table-column prop="tatId" label="机构名称" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="userName" label="姓名" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="cardNo" label="卡号" width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <p>{{doUnicode(scope.row.cardNo)}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="orderNo" label="订单号" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="amout" label="金额" width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <p>{{toDoubleThousands(scope.row.amout)}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="payType" label="支付类型" width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <p>{{scope.row.payType == 2 ? '完美还款' : '极速还款'}}</p>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="finalRes" label="订单状态" width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <p v-if="scope.row.finalRes == 0">成功</p>
                        <p v-else-if="scope.row.finalRes == 1">处理中</p>
                        <p v-else-if="scope.row.finalRes == 2">失败</p>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleSearch(scope.row.id)">查询</el-button>
                    </template>
                </el-table-column>
            </common-table>
        </el-card>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'
    import MPSearch from '@/view/fragment/TransactionManage/MPSearch'

    import OrganService from 'service/OrganService'
    import TransactionService from 'service/TransactionService'
    import privateKey from 'service/constant/privateKey'
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "manualpayment",
        components: {
            CommonTopForm, CommonTable, MPSearch
        },
        data() {
            return {
                formModel: {
                    cardNo: '',
                    amount: '',
                    payType: '2',
                },
                tableData: [],
                payTypes: [],
                page: {},
                submitService: TransactionService.repayApply,
                loading:false,
                isPage:false,
            }
        },
        mounted() {
            this.page = this.$refs.commonTable.page;
            this.getTypeNames('payType', (res) => {
                this.payTypes = res;
            });

            this.getList();
        },
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        computed: {
            submitData() {
                const params = {
                    amount: this.formModel.amount,
                    payType: this.formModel.payType,
                    cardNo: this.formModel.cardNo,
                };
                return params;
            },
            ...mapGetters(['serverType', 'tatId', 'userId'])
        },
        methods: {
            getPage(){
                this.isPage = true;
                this.getList();
            },
            getList() {
                const params = {
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };


                this.doLoad(TransactionService.repayList, params, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.tableData = result.rows;

                        this.page.currentPage = result.current;
                        this.page.total = result.total;
                        this.page.pageSize = result.size;
                        this.isPage = false;
                    });
                }, '信息获取失败')
            },
            handleRepayApply() {
                if (this.formModel.cardNo == '') {
                    return false;
                }
                this.showLoading();
                this.doLoad(TransactionService.repayApply, this.submitData, res => {
                    this.doCheck(res, res => {
                        this.showSuccess(res.contents.optMsg);

                        this.formModel = {
                            cardNo: '',
                            amount: '',
                            payType: '2',
                        };
                        this.getList();
                        this.hideLoading();
                    });
                }, '信息获取失败')
            },
            handleSearch(id) {
                this.loading = true;
                const params = {
                    id: id,
                };

                this.doLoad(TransactionService.queryStatus, params, res => {
                    this.doCheck(res, res => {
                        this.tableData.forEach(item => {
                            if (item.id == res.contents.id) {
                                item.finalRes = res.contents.finalRes;
                                console.log(res.contents.finalRes)
                            }
                        });

                        this.loading = false;
                    });
                }, '信息获取失败')
            },
        }

    }
</script>

<style scoped>
    .box-card {
        margin-bottom: 30px;
    }

    @media only screen and (max-width: 1250px) {
        .card-container {
            background: transparent;
            box-shadow: none;
            padding: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/page/TransactionManage/ManualPayment.vue